import DealerStatus from './DealerStatus';

export default DealerStatus;
